import firebase from 'firebase/app'
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"
import "firebase/functions"
import "firebase/analytics"
import "firebase/messaging"

const config = {
  apiKey: "AIzaSyA4lVQ2lD0ZLXbAGdYT2p115d280hhyVIo",
  authDomain: "filestorage-a7fb3.firebaseapp.com",
  databaseURL: "https://filestorage-a7fb3.firebaseio.com",
  projectId: "filestorage-a7fb3",
  storageBucket: "filestorage-a7fb3.appspot.com",
  messagingSenderId: "941715727152",
  appId: "1:941715727152:web:607485aeb6c4d616e3def5",
  measurementId: "G-GDPF3CP5P6"
  };
firebase.initializeApp(config)
firebase.analytics()

const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser
const functions = firebase.functions()
const storageRef = firebase.storage().ref()
const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null
if (messaging) {
  messaging.usePublicVapidKey("BDxfMB_ownPSDQH2pxe2yEG-fu81JjmZqPXf9CpU2lgF9HkZP0rizAlYqlSl-5SC0PdQXiSFisbivWMPRmz-etk")
}

const usersCollection = db.collection('users')
const assignmentsCollection = db.collection('assignments')
const classesCollection = db.collection('classes')

export {
    firebase,
    db,
    auth,
    currentUser,
    usersCollection,
    assignmentsCollection,
    storageRef,
    classesCollection,
    functions,
    messaging
}